<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2020-12-24 16:46:24
 * @LastEditTime: 2021-03-03 10:57:42
-->
<template>
  <div id="home">
    <div class="home-wrap">
      <section class="search">
        <div class="title">条件筛选</div>
        <el-form :inline="true" :model="form" class="search-form">
          <!-- <el-form-item label="包名">
            <el-select
              v-model="form.pkg"
              multiple
              collapse-tags
              style="width: 350px"
              placeholder="请选择（默认所有）"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="">
            <el-date-picker
              v-model="form.date"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期(默认七天)"
              end-placeholder="结束日期(默认七天)"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" icon="el-icon-search"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </section>
      <section class="data-wrap">
        <div class="title">数据总揽</div>
        <ul class="data-box">
          <li>
            <div class="db-top">
              <span>正在处理</span>
              <strong>{{ ingNum }}</strong>
            </div>
            <div class="db-bottom"><span>当前会话</span>{{ ingNum }}</div>
          </li>
          <li>
            <div class="db-top">
              <span>等待处理</span>
              <strong>{{ waitingNum }}</strong>
            </div>
            <div class="db-bottom"><span>排队列表</span>{{ waitingNum }}</div>
          </li>

          <!-- <li>
            <div class="db-top">
              <span>会话中解决数量</span>
              <strong>12</strong>
            </div>
            <div class="db-bottom"><span>消息总量</span>1</div>
          </li>
          <li>
            <div class="db-top">
              <span>反馈开发数量</span>
              <strong>12</strong>
            </div>
            <div class="db-bottom"><span>留言总量</span>1</div>
          </li> -->
        </ul>
        <!-- <ul class="data-box">
          <li>
            <div class="db-top">
              <span>问题数</span>
              <strong>12</strong>
            </div>
            <div class="db-bottom"><span>问题数</span>1</div>
          </li>
          <li>
            <div class="db-top">
              <span>解决问题数</span>
              <strong>12</strong>
            </div>
            <div class="db-bottom"><span>解决问题数</span>1</div>
          </li>
        </ul> -->
      </section>

      <section class="chart-wrap">
        <div class="title">
          <span>数据图表</span>
          <div class="tabs">
            <div
              v-for="(item, index) in chartTabs"
              :key="index"
              class="tab"
              :class="{ active: activeIndex === index }"
              @click="changeChart(index)"
            >
              {{ item.name }}
            </div>
            <div
              class="tab"
              :class="{ active: activeIndex === 99 }"
              @click="changeChart(99)"
            >
              汇总
            </div>
          </div>
        </div>
        <div class="chart">
          <div
            v-for="(item, index) in returnChatData"
            :key="index"
            class="chart-item"
          >
            <template v-if="item.pkg === curPkg">
              <line-chart :chartdata="item.data" :options="item.option" />
            </template>
          </div>

          <div class="chart-item" v-if="activeIndex === 99">
            <line-chart :chartdata="allData" :options="allOption" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getReportData } from "../../api/chat";
import lineChart from "./line";
export default {
  name: "Dashboard",
  computed: {
    ...mapGetters(["name"]),
    curPkg() {
      if (this.activeIndex !== 99) {
        return this.chartTabs[this.activeIndex].pkg;
      }
    },
  },
  components: {
    lineChart,
  },
  data() {
    return {
      activeIndex: 0,
      chartTabs: [],
      returnChatData: [],
      chartData: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: "Chart.js Line Chart",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      form: {
        pkg: [],
        date: "",
      },
      options: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      waitingNum: 0,
      ingNum: 0,
      no_r: [],
      r: [],
      to_dev: [],
      un_r: [],
      allData: {
        type: "line",
        labels: [],
        datasets: [
          {
            label: "解决数量",
            data: [],
            borderColor: "#f87979",
            borderWidth: 2,
            fill: false,
          },
          {
            label: "不解决数量",
            data: [],
            borderColor: "#434348",
            borderWidth: 2,
            fill: false,
          },
          {
            label: "转开发数量",
            data: [],
            borderColor: "#90ed7d",
            borderWidth: 2,
            fill: false,
          },
          {
            label: "未解决数量",
            data: [],
            borderColor: "#f7a35c",
            borderWidth: 2,
            fill: false,
          },
        ],
      },

      allOption: {
        responsive: true,
        maintainAspectRatio: false,
        // title: {
        //   display: true,
        //   text: key,
        // },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    };
  },

  methods: {
    changeChart(val) {
      this.activeIndex = val;
    },
    getHuizong(arr, type) {
      let arrList = new Array(arr.length).fill(0);
      if (this[type].length > 0) {
        arr.forEach((item, index) => {
          this[type][index] += item;
        });
      } else {
        this[type] = arrList;
        arr.forEach((item, index) => {
          this[type][index] += item;
        });
      }
      return this[type];
    },
    onSubmit() {
      let st = this.form.date ? this.form.date[0] : "";
      let et = this.form.date ? this.form.date[1] : "";
      let pkg = this.form.pkg ? this.form.pkg.join(",") : "";
      let params = {
        st,
        et,
        pkg,
      };
      getReportData(params).then((res) => {
        let resList = [];
        let wNum = 0;
        let iNum = 0;
        let total = {};
        for (let key in res) {
          if (res[key].w_c) {
            wNum = wNum + res[key].w_c;
          }
          if (res[key].p_c) {
            iNum = iNum + res[key].p_c;
          }

          if (res[key].dt) {
            this.allData.labels = res[key].dt;
          }
          if (res[key].r) {
            this.allData.datasets[0].data = this.getHuizong(res[key].r, "r");
          }
          if (res[key].no_r) {
            this.allData.datasets[1].data = this.getHuizong(
              res[key].no_r,
              "no_r"
            );
          }
          if (res[key].to_dev) {
            this.allData.datasets[2].data = this.getHuizong(
              res[key].to_dev,
              "to_dev"
            );
          }
          if (res[key].un_r) {
            this.allData.datasets[3].data = this.getHuizong(
              res[key].un_r,
              "un_r"
            );
          }

          resList.push({
            pkg: key,
            data: {
              type: "line",
              labels: res[key].dt,
              datasets: [
                {
                  label: "解决数量",
                  data: res[key].r,
                  borderColor: "#f87979",
                  borderWidth: 2,
                  fill: false,
                },
                {
                  label: "不解决数量",
                  data: res[key].no_r,
                  borderColor: "#434348",
                  borderWidth: 2,
                  fill: false,
                },
                {
                  label: "转开发数量",
                  data: res[key].to_dev,
                  borderColor: "#90ed7d",
                  borderWidth: 2,
                  fill: false,
                },
                {
                  label: "未解决数量",
                  data: res[key].un_r,
                  borderColor: "#f7a35c",
                  borderWidth: 2,
                  fill: false,
                },
                // {
                //   label: "等待处理",
                //   data: res[key].w_c,
                //   borderColor: "#8085e9",
                //   borderWidth: 2,
                //   fill: false,
                // },
                // {
                //   label: "正在处理",
                //   data: res[key].p_c,
                //   borderColor: "#f15c80",
                //   borderWidth: 2,
                //   fill: false,
                // },
              ],
            },
            option: {
              responsive: true,
              maintainAspectRatio: false,
              // title: {
              //   display: true,
              //   text: key,
              // },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                    },
                  },
                ],
              },
            },
          });
        }
        this.waitingNum = wNum;
        this.ingNum = iNum;

        this.returnChatData = resList;
      });
    },
  },

  mounted() {
    let _group = JSON.parse(localStorage.getItem("pkg"));
    let resList = [];
    if (_group) {
      _group.forEach((gVal) => {
        resList.push({
          value: gVal.pkg,
          label:
            gVal.os === 1 ? gVal.group + " - Android" : gVal.group + " - Ios",
        });
      });
      this.options = resList;

      // 初始化图表
      this.onSubmit();
    }

    let _pkg = JSON.parse(localStorage.getItem("pkg"));
    let _res = [];
    if (_pkg !== null) {
      _pkg.map((item, index) => {
        _res.push({
          pkg: item.pkg,
          name:
            item.os === 0 ? item.group + " - Ios" : item.group + " - Android",
        });
      });
      this.chartTabs = _res;
    }
  },
};
</script>

<style lang="scss" scoped>
#home {
  padding-top: 40px;
}
.home-wrap {
  padding-left: 100px;
}
.title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.data-wrap {
  .data-box {
    display: flex;
    padding-left: 0;
    li {
      width: 200px;
      height: 150px;
      margin-right: 20px;
      border: 1px solid #dddddd;
      list-style: none;
      .db-top {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 90px;
        width: 100%;
        font-size: 12px;
        color: #333333;
        strong {
          margin-top: 10px;
          font-size: 20px;
          color: #409eff;
        }
      }
      .db-bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #dddddd;
        height: 58px;
        width: 100%;
        background: #fafafa;
        font-size: 12px;
        color: #333333;
        span {
          margin-right: 10px;
        }
      }
    }
  }
}
.chart-wrap {
  margin-top: 40px;
  padding-right: 100px;
}
.search {
  margin-bottom: 10px;
}
.search-form {
  margin-top: 16px;
}
.tabs {
  display: flex;
  // align-items: center;
  background: #ffffff;
  color: #409eff;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #409eff;
  .tab {
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    cursor: pointer;
  }
  .active {
    background: #409eff !important;
    // border: 1px solid #409eff;
    color: #ffffff !important;
  }
}
.chart {
  padding-top: 40px;
}
</style>
